<template>
  <v-card>
    <v-card-title class="title">{{ $t('title.location_selection') }} ({{ $t('location_selection.deadline') }}: {{ deadline }})</v-card-title>
    <v-card-text>
      <span class="hint">{{ $t('location_selection.warning') }}</span>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="list"
        hide-default-footer
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.location }}</td>
            <td>
              <v-radio-group
                v-model="choices.first"
                name="choice_first">
                <v-radio :value="item.location"/>
              </v-radio-group>
            </td>
            <td>
              <v-radio-group
                v-model="choices.second"
                name="choice_second">
                <v-radio :value="item.location"/>
              </v-radio-group>
            </td>
            <td>
              <v-radio-group
                v-model="choices.third"
                name="choice_third">
                <v-radio :value="item.location"/>
              </v-radio-group>
            </td>
          </tr>
        </template>

        <div slot="no-data" class="text-center">
          {{ $t('data_table.no_data') }}
        </div>
      </v-data-table>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn type="submit" @click="save" color="primary" :loading="loading">{{ $t('submit') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

import locationSelectionService from '@/services/locationSelection'

export default {
  props: {
    machine: Object
  },

  data () {
    return {
      loading: false,

      choices: {
        first: this.machine.machine_location_selection.choices[0] || '',
        second: this.machine.machine_location_selection.choices[1] || '',
        third: this.machine.machine_location_selection.choices[2] || ''
      },

      headers: [
        { text: this.$t('location_selection.location'), value: 'location', sortable: false },
        { text: this.$t('location_selection.choice_first'), value: '', sortable: false, width: 1 },
        { text: this.$t('location_selection.choice_second'), value: '', sortable: false, width: 1 },
        { text: this.$t('location_selection.choice_third'), value: '', sortable: false, width: 1 }
      ]
    }
  },

  computed: {
    deadline () {
      return moment.unix(this.machine.location_selection.end_at).format('MM/DD/YYYY')
    },
    list () {
      return this.machine.location_selection.locations.map((location) => {
        return {
          location: location
        }
      })
    }
  },

  methods: {
    async save () {
      this.loading = true

      try {
        let response = await locationSelectionService.selectLocation(this.machine.machine_location_selection.id, {
          choices: [
            this.choices.first,
            this.choices.second,
            this.choices.third
          ]
        })
        let index = this.$store.state.machinesData.findIndex((machine) => machine.franchisee_machine_code === this.machine.franchisee_machine_code)
        this.$store.state.machinesData[index].machine_location_selection = response.data.data
        this.$store.commit('SET_MACHINES_DATA', this.$store.state.machinesData)
        this.$toasted.success(this.$t('location_selection.submit')).goAway(5000)
      } catch (error) {
        this.$toasted.error(this.$t('error_message')).goAway(5000)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
